import { useState } from 'react'
import { Document, Page, pdfjs } from 'react-pdf/dist/esm/entry.webpack'
import { PdfReaderProps } from '../../types/props'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

const PdfReader = ({ brochureUrl }: PdfReaderProps) => {
  const [numPages, setNumPages] = useState(null)

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages)
  }

  return (
    <Document
      className='pdf-reader'
      file={{
        url: brochureUrl,
      }}
      onLoadSuccess={onDocumentLoadSuccess}
      onLoadError={(err) => console.log('pdf-reader err', err)}
    >
      {Array.from(new Array(numPages), (el, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          width={360}
          renderTextLayer={false}
        />
      ))}
    </Document>
  )
}

export default PdfReader
